import { CreditCard, FileText, Link2, Nfc, ReceiptText, ShieldCheck, HeartHandshake } from 'lucide-react';
import { MaskedLinesOnView, Reveal } from './Reveal';

export default function Payments({ title, methods, notes, testId = 'payments-section' }) {
  return (
    <div
      data-testid={testId}
      className="relative overflow-hidden rounded-3xl border border-brand-ink/10 bg-brand-parchment p-8 md:p-14"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-24 -top-24 size-64 rounded-full bg-brand-mist/60 blur-3xl"
      />
      <div className="relative grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="flex items-center gap-4 text-[11px] font-semibold uppercase tracking-[0.3em] text-brand-teal">
            <span className="h-px w-10 bg-brand-teal/40" aria-hidden="true" />
            Payment &amp; billing
          </p>
          <MaskedLinesOnView
            as="h2"
            lines={[title]}
            className="mt-6 font-display text-[clamp(2rem,3.5vw,3rem)] font-light leading-tight tracking-tight text-brand-ink"
          />
          {notes.map((note, i) => (
            <Reveal key={i} delay={0.15 + i * 0.08}>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-brand-moss md:text-base">{note}</p>
            </Reveal>
          ))}
        </div>
        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {methods.map((m, i) => (
              <Reveal key={m.label} delay={i * 0.08}>
                <div
                  data-testid={`${testId}-chip-${i}`}
                  className="flex h-full items-center gap-4 rounded-2xl bg-brand-cream p-5 transition-transform duration-500 hover:-translate-y-0.5"
                >
                  <span className="inline-flex size-11 shrink-0 items-center justify-center rounded-xl bg-brand-teal text-brand-cream">
                    <m.icon className="size-5" strokeWidth={1.75} />
                  </span>
                  <span className="text-sm font-semibold leading-snug text-brand-ink">{m.label}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
